import * as Popover from '@rn-primitives/popover';
import { useRef, useState } from 'react';

import { EmojiPickerElement } from './EmojiPickerElement';
import type { EmojiPickerProps } from './emoji-picker.types';

/**
 * Wraps a trigger and opens a full emoji picker in a popover anchored to it,
 * calling `onChange` with the selected emoji. Web implementation using
 * `emoji-picker-element` inside an `@rn-primitives/popover` (Radix on web); the
 * native counterpart lives in `EmojiPicker.native.tsx`.
 */
export function EmojiPicker({ onChange, children }: EmojiPickerProps) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<Popover.TriggerRef>(null);

  return (
    <Popover.Root onOpenChange={setOpen}>
      <Popover.Trigger ref={triggerRef}>{children}</Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          side="bottom"
          align="start"
          sideOffset={6}
          className="overflow-hidden rounded-2xl border border-border bg-card shadow-lg"
        >
          {open ? (
            <EmojiPickerElement
              onPick={(emoji) => {
                onChange(emoji);
                triggerRef.current?.close();
              }}
            />
          ) : null}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
